'use strict';

var stringHasSubstring = function (string, substring) { return string
    .toLowerCase().includes(substring.toLowerCase()); };

exports.stringHasSubstring = stringHasSubstring;
